"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DividerLayout = void 0;
const react_1 = __importDefault(require("react"));
const divider_1 = __importDefault(require("antd/lib/divider"));
const styles_1 = __importDefault(require("./styles"));
const DividerLayout = _ref => {
  let title = _ref.title,
    children = _ref.children;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    style: styles_1.default.container
  }, react_1.default.createElement("div", {
    style: styles_1.default.header
  }, title), children), react_1.default.createElement(divider_1.default, null));
};
exports.DividerLayout = DividerLayout;
exports.default = exports.DividerLayout;